var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.006,
    height: 22,
    viewBox: "0 0 22.006 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d8284a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.069)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.788,3.287a11,11,0,1,0,0,15.564A11.02,11.02,0,0,0,18.788,3.287ZM17.583,17.646a9.3,9.3,0,1,1,0-13.153A9.312,9.312,0,0,1,17.583,17.646Z",
    transform: "translate(0 -0.07)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.085 7.05)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M174.924,171.253l-2.477-2.473,2.477-2.473a.875.875,0,1,0-1.237-1.238l-2.479,2.475-2.479-2.475a.875.875,0,1,0-1.237,1.238l2.477,2.473-2.477,2.473a.875.875,0,0,0,1.237,1.238l2.479-2.475,2.479,2.475a.875.875,0,1,0,1.237-1.238Z",
    transform: "translate(-167.236 -164.813)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2868eace141c73be6df64dad17874b51.svg";
export { ForwardRef as ReactComponent };